import { render, staticRenderFns } from "./templateSingleOptionCard.vue?vue&type=template&id=54845443&scoped=true"
import script from "./templateSingleOptionCard.vue?vue&type=script&lang=js"
export * from "./templateSingleOptionCard.vue?vue&type=script&lang=js"
import style0 from "./templateSingleOptionCard.vue?vue&type=style&index=0&id=54845443&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54845443",
  null
  
)

export default component.exports